<template>
    <div class="scope-chips">
        <span v-if="!ids.length" class="scope-chips__empty">
            <span aria-hidden="true">!</span> Нет доступов
        </span>
        <template v-else>
            <span class="scope-chips__label">{{ label }}:</span>
            <span
                v-for="name in shownNames"
                :key="name"
                :class="['scope-chip', `scope-chip--${kind}`]"
                :title="name"
            >{{ name }}</span>
            <span v-if="restCount > 0" class="scope-chip scope-chip--more" :title="restTitle">
                +{{ restCount }}
            </span>
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const MAX_SHOWN = 3;

const props = defineProps({
    ids: { type: Array, required: true },
    names: { type: Map, required: true },
    kind: { type: String, required: true, validator: value => ['partner', 'advertiser'].includes(value) },
});

const label = computed(() => (props.kind === 'partner' ? 'Партнёры' : 'Рекламодатели'));

const knownNames = computed(() => props.ids
    .map(id => props.names.get(Number(id)))
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b)));

const foreignCount = computed(() => props.ids.length - knownNames.value.length);

const shownNames = computed(() => knownNames.value.slice(0, MAX_SHOWN));

const restCount = computed(() => props.ids.length - shownNames.value.length);

const restTitle = computed(() => {
    const lines = knownNames.value.slice(MAX_SHOWN);
    if (foreignCount.value > 0) lines.push(`и ещё ${foreignCount.value} вне вашей зоны`);
    return lines.join('\n');
});
</script>

<style scoped lang="scss">
@use '../../../../scss/pages/admin/admin-tokens' as *;

.scope-chips {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: $spacing-xs;
    min-width: 0;
}

.scope-chips__label {
    font-size: $font-size-xs;
    color: $admin-text-muted;
    margin-right: 2px;
}

.scope-chips__empty {
    display: inline-flex;
    align-items: center;
    gap: $spacing-xs;
    padding: 2px $spacing-sm;
    border-radius: $radius-sm;
    background: $admin-warning-bg;
    color: $admin-warning-color;
    font-size: $font-size-xs;
    font-weight: 600;
}

.scope-chip {
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 2px $spacing-sm;
    border-radius: 999px;
    border: 1px solid $admin-border-color;
    background: $admin-bg-secondary;
    font-size: $font-size-xs;
    color: $admin-text-secondary;

    &--partner { border-color: #bfdbfe; background: #eff6ff; color: #1e40af; }
    &--advertiser { border-color: #fbcfe8; background: #fdf2f8; color: #9d174d; }
    &--more { cursor: help; font-weight: 600; }
}
</style>
